export default __webpack_public_path__ + "static/media/marauders-map-v5.0-gallery-11.d2a38c4f.jpg";